var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_48293)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1433_48293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5036 14.0151V31.7775C37.5026 33.5857 36.037 35.0516 34.2288 35.0523H8.03064C7.2842 35.0533 6.55989 34.7981 5.97906 34.3293C5.68277 34.0911 5.42969 33.8035 5.23159 33.4788C4.91974 32.9661 4.75517 32.3777 4.75586 31.7775V14.0276L19.0184 26.1044C20.2402 27.1391 22.0314 27.1384 23.2525 26.1026L37.5036 14.0151Z",
    fill: "url(#paint0_linear_1433_48293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5036 14.0004V14.0152L23.2525 26.1024C22.0314 27.1382 20.2402 27.1389 19.0184 26.1041L4.75586 14.0277V14.0004C4.75586 12.1918 6.22211 10.7256 8.03064 10.7256H34.2288C36.0374 10.7256 37.5036 12.1918 37.5036 14.0004Z",
    fill: "url(#paint1_linear_1433_48293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0264 33.4811C36.8283 33.8057 36.5752 34.093 36.2783 34.3309C36.2419 34.3084 36.2088 34.2818 36.1794 34.251L27.9841 25.9126C27.7667 25.6865 27.7715 25.3273 27.9955 25.1071C28.2192 24.8869 28.5784 24.8875 28.8011 25.1088L36.9963 33.4472C37.0071 33.4582 37.0171 33.4697 37.0264 33.4811Z",
    fill: "url(#paint2_linear_1433_48293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2288 25.9116L6.07855 34.2476C6.04847 34.2787 6.01459 34.306 5.97794 34.3292C5.68165 34.091 5.42857 33.8033 5.23047 33.4787C5.23911 33.4673 5.24914 33.4572 5.25916 33.4469L13.4091 25.1109C13.5516 24.9616 13.7631 24.9007 13.9633 24.9508C14.1632 25.0013 14.3208 25.1552 14.3758 25.354C14.4307 25.5528 14.3744 25.7657 14.2288 25.9116Z",
    fill: "url(#paint3_linear_1433_48293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1632 25.5645C42.9986 25.5648 42.841 25.4995 42.7251 25.383L39.7069 22.3647C39.4649 22.1231 39.4649 21.7307 39.7069 21.4886C39.9489 21.2466 40.3413 21.2466 40.583 21.4886L43.6012 24.5069C43.7786 24.6839 43.8315 24.9505 43.7354 25.1821C43.6396 25.4134 43.4138 25.5645 43.1632 25.5645Z",
    fill: "#2561A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9013 21.6818L25.9007 21.6812C24.2415 19.9257 23.3197 17.6003 23.3253 15.1848V15.1836C23.3253 15.0626 23.3276 14.9437 23.3327 14.8268L23.3328 14.8242C23.5344 9.6617 27.8412 5.61649 33.006 5.73809C38.1709 5.85969 42.2826 10.1029 42.2413 15.2687C42.2 20.4349 38.0214 24.6121 32.8553 24.6511L32.848 24.6512L32.8407 24.6515C32.8224 24.6521 32.8032 24.6522 32.7724 24.6522H32.7721C30.7241 24.6535 28.7315 23.9867 27.0964 22.7529C26.6688 22.4303 26.2688 22.0719 25.9013 21.6818Z",
    fill: "url(#paint4_linear_1433_48293)",
    stroke: "#5477D0",
    strokeWidth: 1.03725
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_48293",
    x1: 21.1297,
    y1: 14.0151,
    x2: 21.1297,
    y2: 35.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3796EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_48293",
    x1: 21.1297,
    y1: 10.7256,
    x2: 21.1297,
    y2: 26.8797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1433_48293",
    x1: 32.4253,
    y1: 24.9424,
    x2: 32.4253,
    y2: 34.3309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1433_48293",
    x1: 9.81348,
    y1: 24.9336,
    x2: 9.81348,
    y2: 34.3292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1433_48293",
    x1: 32.7834,
    y1: 5.2168,
    x2: 32.7834,
    y2: 25.1708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_48293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5643,
    height: 43.5643,
    fill: "white",
    transform: "translate(0.21875 0.595703)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1433_48293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.5643,
    height: 43.5643,
    fill: "white",
    transform: "translate(0.21875 0.595703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon13);
export default __webpack_public_path__ + "static/media/mail_card_icon13.f9f75950c7f2765bf9af6b958ee4cdbc.svg";
export { ForwardRef as ReactComponent };